import { render, staticRenderFns } from "./billing-plans.vue?vue&type=template&id=44d28386&lang=pug"
import script from "./billing-plans.vue?vue&type=script&lang=js"
export * from "./billing-plans.vue?vue&type=script&lang=js"
import style0 from "./billing-plans.vue?vue&type=style&index=0&id=44d28386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports